import { UnistylesRuntime } from 'react-native-unistyles';

import {
  BABY_ELEPHANT,
  PINK_OR_PURPLE,
  PINK_OR_PURPLE_25,
  PINK_OR_PURPLE_50,
  PINKLING,
  PINKLING_50,
} from '@/style/colors';

export type DashboardEarningsSeriesItem = {
  key: string;
  label: string;
  color: string;
};

const EARNINGS_SERIES_META = [
  { key: 'dailyRentalsCents', label: 'Daily rentals' },
  { key: 'subscriptionsCents', label: 'Subscriptions' },
  { key: 'deliveryCents', label: 'Delivery' },
  { key: 'missedEarningsCents', label: 'Missed earnings' },
] as const;

export const DASHBOARD_EARNED_SERIES_KEYS = EARNINGS_SERIES_META.slice(
  0,
  3
).map((item) => item.key);

function earningsBrandColors() {
  if (UnistylesRuntime.themeName === 'light') {
    return [PINK_OR_PURPLE, PINK_OR_PURPLE_50, PINK_OR_PURPLE_25] as const;
  }

  return [BABY_ELEPHANT, PINKLING, PINKLING_50] as const;
}

export function dashboardEarningsSeries(
  missedEarningsColor: string
): DashboardEarningsSeriesItem[] {
  const [daily, subscriptions, delivery] = earningsBrandColors();

  return [
    { ...EARNINGS_SERIES_META[0], color: daily },
    { ...EARNINGS_SERIES_META[1], color: subscriptions },
    { ...EARNINGS_SERIES_META[2], color: delivery },
    { ...EARNINGS_SERIES_META[3], color: missedEarningsColor },
  ];
}

export function dashboardShareBarColorsFromSeries(
  series: DashboardEarningsSeriesItem[]
) {
  return {
    daily: series[0].color,
    subscriptions: series[1].color,
  };
}
